module.exports = __webpack_public_path__ + "img/prize_b1.dc0bb9e9.png";